"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [
    ...fragments_1.beginLogInByTransactionFragmentDependencies,
    fragments_1.beginLogInByTransactionFragment,
];
const MUTATION = `
mutation beginLogInByTransaction(
  $walletAddress: String!
  $walletBlockchain: WalletBlockchain!
  $dappAddress: String!
) {
  beginLogInByTransaction(beginLogInByTransactionInput: {
    walletAddress: $walletAddress
    walletBlockchain: $walletBlockchain
    dappAddress: $dappAddress
  }) {
    ...beginLogInByTransactionFragment
  }
}
`.trim();
const beginLogInByTransactionImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'beginLogInByTransaction');
exports.default = beginLogInByTransactionImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmVnaW5Mb2dJbkJ5VHJhbnNhY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvbXV0YXRpb25zL2JlZ2luTG9nSW5CeVRyYW5zYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNENBR3NCO0FBQ3RCLDJFQUc0QztBQU01QyxNQUFNLFlBQVksR0FBRztJQUNuQixHQUFHLHVEQUEyQztJQUM5QywyQ0FBK0I7Q0FDaEMsQ0FBQztBQUVGLE1BQU0sUUFBUSxHQUFHOzs7Ozs7Ozs7Ozs7OztDQWNoQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSwyQkFBMkIsR0FBRyxJQUFBLGdDQUFXLEVBRzdDLElBQUEsd0NBQW1CLEVBQUMsR0FBRyxZQUFZLEVBQUUsUUFBUSxDQUFDLEVBQUUseUJBQXlCLENBQUMsQ0FBQztBQUU3RSxrQkFBZSwyQkFBMkIsQ0FBQyJ9